import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export var ISettingEntry;
(function (ISettingEntry) {
  var SettingType;
  (function (SettingType) {
    SettingType["SETTING_TYPE_UNKNOWN"] = "SETTING_TYPE_UNKNOWN";
    SettingType["CONFIGURATION"] = "CONFIGURATION";
    SettingType["EXPERIMENT"] = "EXPERIMENT";
    SettingType["FEATURE_TOGGLE"] = "FEATURE_TOGGLE";
  })(SettingType = ISettingEntry.SettingType || (ISettingEntry.SettingType = {}));
  var SerializeToClient;
  (function (SerializeToClient) {
    SerializeToClient["SERIALIZE_TO_CLIENT_UNKNOWN"] = "SERIALIZE_TO_CLIENT_UNKNOWN";
    /**
     * Retailer web portal
     */
    SerializeToClient["RETAILER"] = "RETAILER";
    /**
     * Retailer web portal, but only if the auth'd user is logged in
     */
    SerializeToClient["LOGGED_IN_RETAILER"] = "LOGGED_IN_RETAILER";
    /**
     * Legacy neighborhood retailer portal
     * @deprecated
     */
    SerializeToClient["RETAILER_PORTAL"] = "RETAILER_PORTAL";
    /**
     * Brand web portal
     */
    SerializeToClient["MAKER"] = "MAKER";
    /**
     * Legacy neighborhood consumer portal
     * @deprecated
     */
    SerializeToClient["CONSUMER"] = "CONSUMER";
    /**
     * admin2 web
     */
    SerializeToClient["ADMIN"] = "ADMIN";
    /**
     * Help center web
     */
    SerializeToClient["HELP_CENTER"] = "HELP_CENTER";
    /**
     * Brand widget web
     */
    SerializeToClient["BRAND_WIDGET"] = "BRAND_WIDGET";
    /**
     * Retailer android app
     */
    SerializeToClient["RETAILER_ANDROID"] = "RETAILER_ANDROID";
    /**
     * Retailer ios app
     */
    SerializeToClient["RETAILER_IOS"] = "RETAILER_IOS";
    /**
     * Brand android app
     */
    SerializeToClient["BRAND_ANDROID"] = "BRAND_ANDROID";
    /**
     * Brand ios app
     */
    SerializeToClient["BRAND_IOS"] = "BRAND_IOS";
    /**
     * Visitor (logged-out) React app.
     * @deprecated
     */
    SerializeToClient["VISITOR_WEB"] = "VISITOR_WEB";
    /**
     * Shopify Sales Channel app
     */
    SerializeToClient["SHOPIFY_SALES_CHANNEL"] = "SHOPIFY_SALES_CHANNEL";
    /**
     * hotjar for brand web
     */
    SerializeToClient["HOTJAR_BRAND"] = "HOTJAR_BRAND";
    /**
     * hotjar for retailer web
     */
    SerializeToClient["HOTJAR_RETAILER"] = "HOTJAR_RETAILER";
    /**
     * hotjar for help center
     */
    SerializeToClient["HOTJAR_HELP_CENTER"] = "HOTJAR_HELP_CENTER";
    /**
     * Retailer Shopify Integration app
     */
    SerializeToClient["RETAILER_SHOPIFY_INTEGRATION"] = "RETAILER_SHOPIFY_INTEGRATION";
    /**
     * Edge server
     */
    SerializeToClient["EDGE"] = "EDGE";
    /**
     * Shopify Product Sourcing app (will replace RETAILER_SHOPIFY_INTEGRATION)
     */
    SerializeToClient["SHOPIFY_PRODUCT_SOURCING"] = "SHOPIFY_PRODUCT_SOURCING";
    /**
     * Head tags for retailer web
     */
    SerializeToClient["RETAILER_HEAD_TAGS"] = "RETAILER_HEAD_TAGS";
    /**
     * Our beloved dev.faire.team
     */
    SerializeToClient["DEV_PORTAL"] = "DEV_PORTAL";
    /**
     * Our own PR bot
     */
    SerializeToClient["PR_BOT"] = "PR_BOT";
  })(SerializeToClient = ISettingEntry.SerializeToClient || (ISettingEntry.SerializeToClient = {}));
  /**
   * Return an instance of ISettingEntry with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  ISettingEntry.build = function (partial) {
    return _objectSpread({
      serialize_to_pages: [],
      monitor_client_performance: []
    }, partial !== null && partial !== void 0 ? partial : {});
  };
})(ISettingEntry || (ISettingEntry = {}));